import { render } from "./NewDetails.vue?vue&type=template&id=470efbac"
import script from "./NewDetails.vue?vue&type=script&lang=js"
export * from "./NewDetails.vue?vue&type=script&lang=js"

import "./NewDetails.vue?vue&type=style&index=0&id=470efbac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__